// @flow
import React, { Fragment, useCallback, useEffect } from 'react';
import { Container, Button } from 'semantic-ui-react';
import * as cssTele2 from './Manage.module.css';
import * as cssComviq from './ManageComviq.module.css';
import Header from 'views/Header';
import Error from 'views/Error';
import Loading, { Footer } from 'components';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import { infoLogger } from '../../helpers';
import { isComviqCustomer } from '../../helpers/customerTypeHelpers';
import { getContentFor } from '../../helpers/contentHelpers';

const Manage = () => {
  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);

  const isError = useSelector((state) => state.app.isError);

  const allContent = getContentFor(customerType);
  const pageContent = allContent.page.manage;

  const css = isComviq ? cssComviq : cssTele2;

  const completeSubscription = useCallback(() => {
    /*eslint-disable no-undef*/
    DataActivationController.doneSelected();
  }, []);

  useEffect(() => {
    ReactGA.pageview('/manage');
    infoLogger({ name: 'client-manage-page-view', log: `User came to manage component` });
  }, []);

  if (isError) return <Error message={errorMessage} />;
  if (!customerType) return <Loading />;

  return (
    <Fragment>
      <Header />
      <main>
        {isComviq ? (
          <>
            <Container className={css.container}>
              <h1 className={css.title}>{pageContent.title}</h1>
              <ReactMarkdown source={pageContent.text} />
              <Footer className={css.footer} isComviq={true}>
                <Button color="pink" primary fluid onClick={completeSubscription}>
                  Ok
                </Button>
              </Footer>
            </Container>
          </>
        ) : (
          <>
            <Container>
              <h1 className={css.title}>{pageContent.title}</h1>
              <ReactMarkdown source={pageContent.text} />
              <Button color="black" className={`${css.close} link`} primary fluid onClick={completeSubscription}>
                Stäng
              </Button>
            </Container>
          </>
        )}
      </main>
    </Fragment>
  );
};

export default withRouter(Manage);
